import $api from "@/frontend/shared/api/axios";
import { ConditionRowFilterExtended } from "@/frontend/components/FilterV2/model/types";
import { TSortables, TSortDirection } from "@/frontend/pages/CompaniesPage/model/types/types";

type TPostSearchCompanies = {
  page: number;
  limit: number;
  filters: ConditionRowFilterExtended[];
  sortBy?: TSortables;
  sortOrder?: TSortDirection;
};

export async function postSearchCompanies(props: TPostSearchCompanies, options: any = {}) {
  const { page = 1, limit, filters, sortBy, sortOrder } = props;

  const requestBody = {
    page,
    limit,
    filters,
    sortBy: sortBy && sortOrder ? sortBy : undefined,
    sortOrder: sortBy && sortOrder ? sortOrder : undefined
  };

  const res = await $api.post(`/search/companiesFiltersV2`, requestBody, options);

  return res.data.data;
}
